'use strict';
  
angular.module('sellersService', [])
.factory('AuthenticationService', ['appInfo', 'localstorage', '$window', '$log', 'Base64', '$cookieStore', '$q', '$http', '$rootScope', '$timeout',
    function ( appInfo, localstorage, $window, $log, Base64, $cookieStore, $q, $http, $rootScope, $timeout) {
        
        var service = {};

        /* Use this for api authentication
        ----------------------------------------------*/
        service.Login = function (login, username, password, callback) {
            var credentials = {"username": username, "password": password };
            var authdata = Base64.encode(JSON.stringify(credentials));
            var dfd = $q.defer();
            
            $http({
                url: appInfo.endpoint+'otherusers/login.json',
                method: "GET",
                params: {logindetails: authdata, api_key: appInfo.key}
            }).success(function (data, status, headers, config){
                callback(data);
            }).error(function (data, status, headers, config){ 
                callback(data);
            });

        };
  
        service.SetAccess = function (data) {
            var accessKey = data.access;
            var userLastAccess = parseInt(data.userLastAccess);
            var user = (typeof data.userDetails.result !=='undefined')? data.userDetails.result: data.userDetails;
            var agencies = [];
            $rootScope.currentUser = {};

            // For members, agency is an array but for 'others' it is an object
            if(typeof user[0].agency == 'array') {
                for(var i=0; i < user[0].agency.length; i++) {
                    var identifier = user[0].agency[i].identifier;
                    var organisation = user[0].agency[i].organisation;
                    var roles = user[0].agency[i].roles.split(",");
                    agencies.push({'identifier':identifier, 'organisation': organisation, 'roles':roles});
                }
            } else {
                var identifier = user[0].agency.identifier;
                var organisation = user[0].agency.organisation;
                var roles = user[0].agency.roles.split(",");
                agencies.push({'identifier':identifier, 'organisation': organisation, 'roles':roles});
            }
            
            // Add details for current user to $rootScope
            $rootScope.currentUser.authdata = accessKey;
            $rootScope.currentUser.id = user[0].id;
            $rootScope.currentUser.name = user[0].nameFirst+' '+user[0].nameLast;
            $rootScope.currentUser.info = user[0].info;
            $rootScope.currentUser.userAgent = $window.navigator.userAgent;
            $rootScope.currentUser.agencies = agencies;
            
            $rootScope.authload = true;

            $http.defaults.headers.common['Authorization'] = accessKey;
            $rootScope.auth = true;

            //Set Cookies
            $cookieStore.put('currentUser', $rootScope.currentUser, {path: '/seller'});
            $cookieStore.put('accessKey', accessKey, {path: '/seller'});
            $cookieStore.put('lastLogin', userLastAccess, {path: '/seller'});

            //Set LocalStorage
            localstorage.setObject('currentUser', $rootScope.currentUser);
            localstorage.set('accessKey', accessKey);
            localstorage.set('lastLogin', userLastAccess);

            if(typeof $cookieStore.get('lastLogin') == 'undefined'){
                var lDate = new Date();
                lDate.setDate(lDate.getDate()-7);
                var ts = Math.round(lDate.getTime()/1000);
                $cookieStore.put('lastLogin', ts, {path: '/seller'});
                localstorage.set('lastLogin', ts);
             }
        };

        service.LogOut = function(accessKey, callback) {
            var lDate = new Date();
            var ts = Math.round(lDate.getTime()/1000);

            $cookieStore.put('lastLogin', ts, {path: '/seller'});
            localstorage.set('lastLogin', ts);

            $http({
                url: appInfo.endpoint+'wolusers/logout.json', 
                method: "GET",
                params: {usercode: accessKey, api_key: key}
            }).success(function (data, status, headers, config){
                callback('success');
            }).error(function (data, status, headers, config){ 
                callback('error');
            });
        };

        service.ClearLocalCache = function () {
            localstorage.empty();
        };
  
        service.ClearCredentials = function () {
            //Reset $rootScope vars
            $rootScope.currentUser = {};
            $rootScope.currentListing = {};
            $rootScope.auth = false;

            //Remove Cookies
            $cookieStore.remove('currentUser');
            $cookieStore.remove('accessKey');
            $cookieStore.remove('lastLogin');

            var foundationPopupShown = localstorage.get('foundationPopupShown'); //is set in page header directive
            var vasyPopupShown = localstorage.get('vasyPopupShown'); //is set in page header directive
            
            //Remove LocalStorage
            localstorage.remove('currentUser');
            localstorage.remove('accessKey');
            localstorage.remove('lastLogin');
            localstorage.empty();

            //localstorage.set('foundationPopupShown', foundationPopupShown);
             
            localstorage.set('vasyPopupShown', vasyPopupShown);

        };
  
        return service;
    }])
  
.factory('Base64', function () {
    /* jshint ignore:start */
  
    var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  
    return {
        encode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
  
            do {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
  
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
  
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
  
                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);
  
            return output;
        },
  
        decode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
  
            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            var base64test = /[^A-Za-z0-9\+\/\=]/g;
            if (base64test.exec(input)) {
                window.alert("There were invalid base64 characters in the input text.\n" +
                    "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                    "Expect errors in decoding.");
            }
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  
            do {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));
  
                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;
  
                output = output + String.fromCharCode(chr1);
  
                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }
  
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
  
            } while (i < input.length);
  
            return output;
        }
    };
  
    /* jshint ignore:end */
})

.factory('localstorage', ['$window', function($window) {
  return {
    set: function(key, value) {
        if(typeof($window.localStorage) != 'undefined'){ 
            $window.localStorage.setItem(key, value);
        } 
        else{ 
            throw "window.localStorage, not defined"; 
        }
    },
    get: function(key) {
      return $window.localStorage.getItem(key);
    },
    remove: function(key){
        $window.localStorage.removeItem(key);
    },
    empty: function(){
        $window.localStorage.clear();
    },
    setObject: function(key, value) {
        if(typeof($window.localStorage) != 'undefined'){ 
            $window.localStorage.setItem(key, JSON.stringify(value));
        } 
        else{ 
            throw "window.localStorage, not defined"; 
        }
    },
    getObject: function(key) {
        var retrievedObj = $window.localStorage.getItem(key);
      return JSON.parse(retrievedObj || '{}');
    }
  }
}]);